import React, { createContext } from "react"
import { SeloPremiadoFornecedorInicial, type SeloPremiadoFornecedorModel } from "../models/seloPremiadoFornecedorModel"
import type { SeloPremiadoFornecedorAction } from "./seloPremiadoFornecedorActions"

type SeloPremiadoFornecedorContextType = {
    dados: SeloPremiadoFornecedorModel
    dispatch: React.Dispatch<SeloPremiadoFornecedorAction>
    erroCarregamento: string | null
    recarregar: (busca?: string) => Promise<void>
}

export const SeloPremiadoFornecedorContext = createContext<SeloPremiadoFornecedorContextType>({
    dados: SeloPremiadoFornecedorInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    recarregar: async () => undefined,
})
